<template>
  <div class="user-subscriptions_usb" :class="{ [curTheme]: true }">

    <page-header>
      <nav-inner :use-user-links="true"/>
    </page-header>

    <div class="page-container_pcr">
      <router-link
        class="help-link"
        :to="{ path: '/help/34'}"
        target="_blank">
        Подробнее о моих подписках в разделе Помощь
      </router-link>
      <template
        v-if="!isLoading && filtersDisplay && filtersDisplay.length > 0
          && Object.keys(filtersDisplay[0]).length > 0">
        <p>Список ваших подписок, соответствующих определенных вами параметрам поиска.
          Информирование о появлении новых объектов на платформе осуществляется
          по электронной почте.</p>
        <div
          v-for="(o, i) in filtersDisplay"
          :key="`subs-${i}`" class="usb_item">
          <el-tooltip
            :hide-after="1000"
            content="Удалить подписку"
            placement="top">
            <button @click="unsubscribe(subsData[i].id)" class="usb_item-close">
              <i class="el-icon-delete"></i>
            </button>
          </el-tooltip>
          <div class="usb_title">Подписка создана {{ formatDate(o.created_at) }}</div>
          <ul class="usb_info">
            <template
              v-for="(val, id, j) in o">
              <li
                v-if="id === 'dateStart'"
                class="usb_info-item"
                :key="`filter-${j}`">
                <span class="usb_color-grey">Дата депонирования:</span>
                с {{ filtersDisplay[i]['dateStart'] }}
                по {{ filtersDisplay[i]['dateEnd'] }}
              </li>
              <li
                v-else-if="id !== 'dateEnd' && id !== 'created_at'"
                class="usb_info-item"
                :key="`filter-${j}`">
                <span class="usb_color-grey">{{ searchFilters[id].title }}:</span> {{ val }}
              </li>
            </template>
          </ul>
        </div>
      </template>
      <template v-else-if="!isLoading">
        <div class="no-results">
          Ваш список подписок пуст.
          <div
            class="depo-msg_dmg dmg_themable">
            <div class="dmg_mail"><i class="el-icon-message"></i></div>
            <div class="dmg_text">Чтобы подписаться на получение e-mail уведомлений о появлении
              новых ЦОАП, соответствующих определенным вами параметрам, произведите поиск
              в каталоге объектов по любому набору параметров, после чего нажмите на кнопку
              «Информирование о новых ЦОАП», которая находится над результатами поиска.
            </div>
          </div>
        </div>
      </template>

    </div>

    <page-footer/>

  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import Vue from 'vue';
import PageHeader from '../PageHeader';
import PageFooter from '../PageFooter';
import NavInner from '../NavInner';
import SearchFilters from '../../mixins/SearchFilters';

export default {

  components: { PageHeader, PageFooter, NavInner },

  mixins: [SearchFilters],

  data() {
    return {
      subsData: null,
      isLoading: false,
    };
  },

  mounted() {
    this.fetchData();
  },

  methods: {

    fetchData() {
      Vue.$loading.on();
      this.isLoading = true;
      axios.get('subscribe/my').then((r) => {
        this.subsData = r.data;
        this.subsData.forEach((subData, i) => {
          Object.keys(subData).forEach((filterId) => {
            if (['created_at', 'id'].indexOf(filterId) === -1) {
              this.filtersHandler(i, filterId, subData[filterId]);
            }
          });
        });
      }).catch(() => {
        this.$notify.error('Ошибка при получении данных подписок.');
      }).finally(() => {
        Vue.$loading.off();
        this.isLoading = false;
      });
    },

    formatDate(date) {
      return moment(date).format('DD.MM.YYYY');
    },

    unsubscribe(id) {
      this.$confirm('Удалить подписку на рассылку о появлении ' +
        'новых объектов этого профиля поиска?', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
      }).then(() => {
        let message = '';
        axios.post('subscribe/remove/my', { id }).then((r) => {
          message = r.data;
          const i = this.subsData.findIndex(item => item.id === id);
          this.subsData.splice(i, 1);
          this.filtersDisplay.splice(i, 1);
        }).catch((err) => {
          message = err.response.data;
        }).finally(() => {
          this.$alert(message);
        });
      }).catch(() => {});
    },

  },

};
</script>

<style lang="scss">
@import "../../styles/common/main";

.user-subscriptions_usb {
  .usb_item {
    padding: 25px;
    @include border-radius(7px);
    background: rgba(125, 125, 125, .2);
    margin: 30px 0;
    display: block;
    text-align: left;
    @include transition;
    position: relative;
    @media (max-width: 500px) {
      padding: 15px;
    }
    .usb_item-close {
      position: absolute;
      right: 20px;
      top: 16px;
      color: #fff;
      font-size: 18px;
      opacity: .5;
      @include transition;
      cursor: pointer;
      &:hover {
        opacity: 1;
      }
    }
    .usb_title {
      font-size: 20px;
      line-height: 25px;
      font-weight: bold;
      padding-right: 40px;
    }
    .usb_color-grey {
      color: #999;
    }
    .usb_info {
      margin: 10px 0 0;
      @media (max-width: 600px) {
        padding-left: 25px;
      }
    }
  }
  &.theme-w {
    .usb_item {
      background: rgba(125, 125, 125, .1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/UserSubscriptions.vue